import React from 'react';

/** Nav-arrow glyph for the recenter / my-location map FAB (does not open Maps). */
export default function MapRecenterIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M4.5 12.5L19 4.5l-4.2 15.2-3.3-5.6-5.5-1.6z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
